import React, { useEffect } from "react";

const listNames = (names) =>
  names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}` : names[0];

// "Keep this one" on a conflict: the kept document stays and the other one is deleted.
const KeepConflictDialog = ({ keep, other, onCancel, onConfirm }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onCancel();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  const otherConflicts = Math.max(0, (other.open_conflicts || 1) - 1);
  const notes = [
    otherConflicts > 0 && `Also closes its ${otherConflicts} other ${otherConflicts === 1 ? "conflict" : "conflicts"}.`,
    other.folders?.length ? `In ${listNames(other.folders)}.` : "Not in any folder.",
    other.uploaded_by && `Uploaded by ${other.uploaded_by}.`,
  ].filter(Boolean);

  return (
    <div className="fixed inset-0 z-[9999] bg-[rgba(24,16,28,0.45)] flex items-center justify-center">
      <div role="dialog" aria-modal="true" className="w-[480px] max-w-[92vw] bg-white rounded-xl p-6 shadow-[0_24px_48px_rgba(24,16,28,0.3)] flex flex-col gap-4 font-outfit">
        <div className="flex flex-col gap-[6px]">
          <p className="m-0 text-[18px] font-semibold text-[#18181B] break-words">Keep “{keep.name}”?</p>
          <p className="m-0 text-[14px] leading-[1.5] text-[#3F3F46] break-words">
            <b className="font-semibold">“{other.name}”</b> will be deleted from the Knowledge Base. This is permanent and
            can't be undone.
          </p>
        </div>
        <div className="flex flex-col gap-1 px-3 py-[10px] bg-[#FAFAFA] border border-[#E4E4E7] rounded-md text-[13px] leading-[1.45] text-[#3F3F46]">
          {notes.map((note) => (
            <p key={note} className="m-0">
              {note}
            </p>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-5 py-2 border border-[#A1A1AA] rounded-md bg-white hover:bg-[#F4F4F5] text-[14px] font-medium text-[#27272A]"
          >
            Cancel
          </button>
          <button
            type="button"
            autoFocus
            onClick={() => onConfirm("delete")}
            className="px-5 py-2 border border-[#B42318] rounded-md bg-[#B42318] hover:bg-[#912018] text-white text-[14px] font-medium"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default KeepConflictDialog;
